import React, { useState } from 'react';
import { UploadContainer, Upload, FormField } from '@vwfs-bronson/bronson-react';
import { FileUploadItems } from './file-upload-items/FileUploadItems';
import { useField } from 'formik';

export type FileUploadProps = {
    name: string;
    descriptionText?: string;
    descriptionSupplementaryText?: string;
    buttonText?: string;
    disabled?: boolean;
    disabledText?: string;
    disabledSupplementaryText?: string;
    multiple?: boolean;
    accept?: string;
    loading?: boolean;
    processingText?: React.ReactNode;
    className?: string;
    maxFileSize?: number;
    validFileFormats?: string[];
    sizeError?: string | React.ReactNode;
    typeError?: string | React.ReactNode;
    sizeAndTypeError?: string | React.ReactNode;
};

export const FileUpload: React.FC<FileUploadProps> = ({
    maxFileSize,
    validFileFormats,
    sizeError,
    typeError,
    sizeAndTypeError,
    ...rest
}) => {
    const [field, meta, helpers] = useField(rest.name);
    const [filesList, setFilesList] = useState<File[]>(field.value);

    const removeFile = (index: number): void => {
        const fileListCopy = [...filesList];
        fileListCopy.splice(index, 1);
        setFilesList(fileListCopy);

        helpers.setValue(fileListCopy);
    };

    const fileChangedHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const target = event.target as HTMLInputElement;
        const files: FileList | null = target.files;
        const array = Array.prototype.slice.call(files);
        setFilesList([...filesList, ...array]);

        helpers.setValue([...filesList, ...array]);
        target.value = '';
    };

    return (
        <FormField type="input" required testId={'upload-form-field'}>
            <UploadContainer
                uploadItemsLabel={rest.name}
                upload={
                    <Upload
                        aria-required="true"
                        aria-describedby={`error-${rest.name}`}
                        id={rest.name}
                        onChange={fileChangedHandler}
                        {...rest}
                    />
                }
            >
                <FileUploadItems
                    files={filesList}
                    removeFile={removeFile}
                    validFileFormats={validFileFormats}
                    maxFileSize={maxFileSize}
                    sizeError={sizeError}
                    typeError={typeError}
                    sizeAndTypeError={sizeAndTypeError}
                />
            </UploadContainer>
            {meta.error && (
                <div id={`error-${rest.name}`} className="c-error-message u-mb-small">
                    {meta.error}
                </div>
            )}
        </FormField>
    );
};
